








































import Channel from '@/components/guide/Channel.vue';
import GuideDaySelectDialog from '@/components/guide/GuideDaySelectDialog.vue';
import GuideMainMenu from '@/components/guide/GuideMainMenu.vue';
import GuideScroller from '@/components/guide/GuideScroller.vue';
import GuideTimeSelector from '@/components/guide/GuideTimeSelector.vue';
import Loading from '@/components/guide/Loading.vue';
import ProgramDialog from '@/components/guide/ProgramDialog.vue';
import TimeLine from '@/components/guide/TimeLine.vue';
import TimeScale from '@/components/guide/TimeScale.vue';
import OnAirSelectStream from '@/components/onair/OnAirSelectStream.vue';
import TitleBar from '@/components/titleBar/TitleBar.vue';
import container from '@/model/ModelContainer';
import ISocketIOModel from '@/model/socketio/ISocketIOModel';
import IGuideState, { FetchGuideOption } from '@/model/state/guide/IGuideState';
import IScrollPositionState from '@/model/state/IScrollPositionState';
import ISnackbarState from '@/model/state/snackbar/ISnackbarState';
import { IGuideSizeSettingStorageModel } from '@/model/storage/guide/IGuideSizeSettingStorageModel';
import { ISettingStorageModel, ISettingValue } from '@/model/storage/setting/ISettingStorageModel';
import UaUtil from '@/util/UaUtil';
import Util from '@/util/Util';
import { debounce, throttle } from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';

Component.registerHooks(['beforeRouteUpdate', 'beforeRouteLeave']);

@Component({
    components: {
        TitleBar,
        GuideMainMenu,
        GuideTimeSelector,
        Loading,
        Channel,
        TimeScale,
        GuideScroller,
        TimeLine,
        ProgramDialog,
        OnAirSelectStream,
        GuideDaySelectDialog,
    },
})
export default class Guide extends Vue {
    public isLoading: boolean = true;
    public guideState: IGuideState = container.get<IGuideState>('IGuideState');
    public isOpenDaySelectDialog: boolean = false;

    private scrollState: IScrollPositionState = container.get<IScrollPositionState>('IScrollPositionState');
    private setting: ISettingStorageModel = container.get<ISettingStorageModel>('ISettingStorageModel');
    private settingValue: ISettingValue | null = null;
    private sizeSetting = container.get<IGuideSizeSettingStorageModel>('IGuideSizeSettingStorageModel');
    private snackbarState: ISnackbarState = container.get<ISnackbarState>('ISnackbarState');
    private socketIoModel: ISocketIOModel = container.get<ISocketIOModel>('ISocketIOModel');
    private onUpdateStatusCallback = ((): void => {
        this.guideState.updateReserves();
    }).bind(this);

    private programBaseWidth: number = 140;
    private programBaseHeight: number = 180;

    private scrollCallback = throttle(() => {
        this.setDisplayRange();
        this.guideState.updateVisible();
    }, 10);

    private windowResizeCallback = debounce(() => {
        this.updateBaseSize();
        this.setDisplayRange();
        this.guideState.updateVisible();
    }, 100);

    private isiOS: boolean = false;

    get darkClassList(): any {
        return {
            'is-dark': this.settingValue?.isForceDisableDarkThemeForGuide !== true && this.$vuetify.theme.dark === true,
        };
    }

    get programsStyle(): any {
        const width = `calc(${this.guideState.getChannelsLength()} * var(--channel-width))`;
        const height = `calc(${this.guideState.getTimesLength()} * var(--timescale-height))`;

        return {
            'min-width': width,
            'max-width': width,
            width,
            'min-height': height,
            'max-height': height,
            height,
        };
    }

    public created(): void {
        this.settingValue = this.setting.getSavedValue();
        this.isiOS = UaUtil.isiOS();

        // リサイズイベント追加
        window.addEventListener('resize', this.windowResizeCallback, false);

        // socket.io イベント
        this.socketIoModel.onUpdateState(this.onUpdateStatusCallback);

        if (UaUtil.isiOS() === true) {
            // html の class に guide を追加
            const element = document.getElementsByTagName('html')[0];
            element.classList.add('fix-address-bar');
        }
    }

    public beforeDestroy(): void {
        // リサイズイベント追加
        window.removeEventListener('resize', this.windowResizeCallback, false);

        // socket.io イベント
        this.socketIoModel.offUpdateState(this.onUpdateStatusCallback);

        if (UaUtil.isiOS() === true) {
            // html の class から guide を削除
            const element = document.getElementsByTagName('html')[0];
            element.classList.remove('fix-address-bar');
        }
    }

    /**
     * タイトルクリック
     */
    public onTitle(): void {
        this.isOpenDaySelectDialog = true;
    }

    /**
     * ジャンル情報の更新
     */
    public onUpdateGenre(): void {
        this.isLoading = true;
        this.$nextTick(() => {
            this.guideState.updateGenre();
            this.isLoading = false;
        });
    }

    /**
     * 番組表スクロールイベント
     */
    public onProgramScroll(e: Event): void {
        if (typeof this.$refs.channels === 'undefined' || typeof this.$refs.times === 'undefined') {
            return;
        }

        const element = e.target as HTMLElement;
        (this.$refs.channels as HTMLElement).scrollLeft = element.scrollLeft;
        (this.$refs.times as HTMLElement).scrollTop = element.scrollTop;

        // スクロールバーサイズ
        const scrollBarLeft = element.offsetWidth - element.clientWidth;
        const scrollBarTop = element.offsetHeight - element.clientHeight;

        // iOS 端末で scroll 値がマイナス or 要素より大きい場合に描画を更新するとブルブルすためスクロール値を見る
        if (
            this.isiOS === false ||
            (element.scrollLeft >= 0 &&
                element.scrollTop >= 0 &&
                element.scrollLeft <= this.programBaseWidth * this.guideState.getChannelsLength() - element.offsetWidth + scrollBarLeft &&
                element.scrollTop <= this.programBaseHeight * this.guideState.getTimesLength() - element.offsetHeight + scrollBarTop)
        ) {
            this.scrollCallback();
        }
    }

    /**
     * ページ更新時に呼ばれる
     */
    public beforeRouteUpdate(to: Route, from: Route, next: () => void): void {
        this.saveScrollPosition();
        next();
    }

    /**
     * ページ離脱時に呼ばれる
     */
    public beforeRouteLeave(to: Route, from: Route, next: () => void): void {
        this.saveScrollPosition();
        next();
    }

    /**
     * スクロール位置を記録する
     */
    private saveScrollPosition(): void {
        if (typeof this.$refs.programs === 'undefined') {
            return;
        }

        try {
            this.scrollState.saveScrollData({
                x: (this.$refs.programs as GuideScroller).$el.scrollLeft,
                y: (this.$refs.programs as GuideScroller).$el.scrollTop,
            });
        } catch (err) {
            console.error(err);
        }
    }

    @Watch('$route', { immediate: true, deep: true })
    public onUrlChange(): void {
        this.isLoading = true;
        this.guideState.clearDate();
        this.$nextTick(async () => {
            this.setSizeSetting();
            this.updateBaseSize();
            // 番組表データ取得
            try {
                await this.guideState.fetchGuide(this.createFetchGuideOption());
            } catch (err) {
                this.isLoading = false;
                this.snackbarState.open({
                    text: '番組表情報の取得に失敗しました',
                    color: 'error',
                });
                console.error(err);

                // データ取得完了を通知
                await this.scrollState.emitDoneGetData();

                return;
            }

            // データ取得完了を通知
            await this.scrollState.emitDoneGetData();

            if (typeof this.$refs.programs !== 'undefined') {
                this.setDisplayRange();
                this.guideState.createProgramDoms(typeof this.$route.query.channelId !== 'undefined');

                if (typeof this.$refs.content !== 'undefined') {
                    // スクロール位置復元
                    if (this.scrollState.isNeedRestoreHistory === true) {
                        const position = this.scrollState.getScrollData<{ x: number; y: number }>();
                        if (position !== null) {
                            (this.$refs.programs as GuideScroller).$el.scrollLeft = position.x;
                            (this.$refs.programs as GuideScroller).$el.scrollTop = position.y;
                        }
                        this.scrollState.isNeedRestoreHistory = false;
                    } else {
                        // スクロール位置初期化
                        (this.$refs.programs as GuideScroller).$el.scrollLeft = 0;
                        (this.$refs.programs as GuideScroller).$el.scrollTop = 0;
                        if (typeof this.$refs.channels !== 'undefined' && typeof this.$refs.times !== 'undefined') {
                            (this.$refs.channels as HTMLElement).scrollLeft = 0;
                            (this.$refs.times as HTMLElement).scrollTop = 0;
                        }
                    }

                    // 時刻線要素を退避
                    const timeline = (this.$refs.content as HTMLElement).getElementsByClassName('time-line')[0];

                    // 追加する前に前回の子要素を削除
                    while ((this.$refs.content as HTMLElement).firstChild) {
                        const firstChild = (this.$refs.content as HTMLElement).firstChild;
                        if (firstChild !== null) {
                            (this.$refs.content as HTMLElement).removeChild(firstChild);
                        }
                    }

                    // 時刻線要素を元に戻す
                    (this.$refs.content as HTMLElement).appendChild(timeline);

                    await Util.sleep(100);
                    const programDoms = this.guideState.getProgramDoms();
                    const domsLength = programDoms.length;
                    for (let i = 0; i < domsLength; i++) {
                        (this.$refs.content as HTMLElement).appendChild(programDoms[i].element);
                        if (i % 500 === 0) {
                            await Util.sleep(1);
                        }
                    }

                    this.guideState.updateVisible();

                    // 番組表を矢印キーで操作できるようにフォーカスする
                    if (UaUtil.isAndroid() === false && typeof this.$refs.programs !== 'undefined') {
                        const el = (this.$refs.programs as GuideScroller).$el as HTMLElement;
                        el.tabIndex = -1; //tabIndex を設定することで forcus() が効くようにする
                        el.focus();
                        el.style.outline = 'none'; // tabIndex 設定時に forcus されると outline が表示されるので削除
                    }
                }
            }

            this.$nextTick(() => {
                this.isLoading = false;
            });
        });
    }

    /**
     * 各種サイズ設定を行う
     */
    private setSizeSetting(): void {
        const sizeValue = this.sizeSetting.getSavedValue();
        this.setCssVariable('--channel-tablet-height', `${sizeValue.tablet.channelHeight}px`);
        this.setCssVariable('--channel-tablet-width', `${sizeValue.tablet.channelWidth}px`);
        this.setCssVariable('--channel-tablet-fontsize', `${sizeValue.tablet.channelFontsize}px`);
        this.setCssVariable('--timescale-tablet-height', `${sizeValue.tablet.timescaleHeight}px`);
        this.setCssVariable('--timescale-tablet-width', `${sizeValue.tablet.timescaleWidth}px`);
        this.setCssVariable('--timescale-tablet-fontsize', `${sizeValue.tablet.timescaleFontsize}px`);
        this.setCssVariable('--program-tablet-fontsize', `${sizeValue.tablet.programFontSize}pt`);

        this.setCssVariable('--channel-mobile-height', `${sizeValue.mobile.channelHeight}px`);
        this.setCssVariable('--channel-mobile-width', `${sizeValue.mobile.channelWidth}px`);
        this.setCssVariable('--channel-mobile-fontsize', `${sizeValue.mobile.channelFontsize}px`);
        this.setCssVariable('--timescale-mobile-height', `${sizeValue.mobile.timescaleHeight}px`);
        this.setCssVariable('--timescale-mobile-width', `${sizeValue.mobile.timescaleWidth}px`);
        this.setCssVariable('--timescale-mobile-fontsize', `${sizeValue.mobile.timescaleFontsize}px`);
        this.setCssVariable('--program-mobile-fontsize', `${sizeValue.mobile.programFontSize}pt`);
    }

    /**
     * set css variables
     * @param name
     * @param value
     */
    private setCssVariable(name: string, value: string): void {
        const element = document.querySelector('.app-content.guide');
        if (element === null) {
            return;
        }
        (element as HTMLElement).style.setProperty(name, value);
    }

    /**
     * programBaseWidth, programBaseHeight の更新
     */
    private updateBaseSize(): void {
        this.programBaseWidth = this.getCssVariable('--channel-width');
        this.programBaseHeight = this.getCssVariable('--timescale-height');
    }

    /**
     * get CSS Variables
     * @param name
     * @return number
     */
    private getCssVariable(name: string): number {
        const element = document.querySelector('.app-content.guide');
        if (element === null) {
            return 0;
        }
        const style = window.getComputedStyle(element);

        const result = parseInt(style.getPropertyValue(name).trim().replace('px', ''), 10);

        return isNaN(result) === true ? 0 : result;
    }

    /**
     * FetchGuideOption を生成する
     * @return FetchGuideOption
     */
    private createFetchGuideOption(): FetchGuideOption {
        if (this.settingValue === null) {
            throw new Error('SettingValueIsNull');
        }

        const result: FetchGuideOption = {
            length: this.settingValue.guideLength,
            isHalfWidth: this.settingValue.isHalfWidthDisplayed,
        };

        if (typeof this.$route.query.type !== 'undefined') {
            result.type = this.$route.query.type as any;
        }

        if (typeof this.$route.query.time !== 'undefined') {
            result.time = this.$route.query.time as any;
        }

        if (typeof this.$route.query.channelId !== 'undefined') {
            result.channelId = parseInt(this.$route.query.channelId as any, 10);
        }

        return result;
    }

    private setDisplayRange(): void {
        this.guideState.setDisplayRange({
            baseWidth: this.programBaseWidth,
            baseHeight: this.programBaseHeight,
            maxWidth: ((this.$refs.programs as GuideScroller).$el as HTMLElement).offsetWidth,
            maxHeight: ((this.$refs.programs as GuideScroller).$el as HTMLElement).offsetHeight,
            offsetWidth: (this.$refs.programs as GuideScroller).$el.scrollLeft,
            offsetHeight: (this.$refs.programs as GuideScroller).$el.scrollTop,
        });
    }
}
